// extracted by mini-css-extract-plugin
module.exports = {"component":"refer-a-friend_component__C0Zv4","sticky":"refer-a-friend_sticky__DjPXo"};